export default __webpack_public_path__ + "static/media/menu.d948da49.png";